import { Navigate } from '@tanstack/react-router';
import { type ReactNode } from 'react';

import { env } from '../../env';
import { AccessDeniedPage } from '../../pages/AccessDeniedPage/AccessDeniedPage';
import { loginRoute } from '../../pages/LoginPage/route';

import { useHasValidTokens } from './hooks/useHasValidTokens';
import { useRedirectToStoredUrlAfterAuth } from './hooks/useRedirectAfterAuth';

export type FipAuthGuardProps = {
	children: ReactNode;
};

export const FipAuthGuard = ({ children }: FipAuthGuardProps) => {
	const { hasValidTokens } = useHasValidTokens();

	useRedirectToStoredUrlAfterAuth({
		hasValidTokens,
	});

	if (hasValidTokens) {
		return children;
	}

	const isLocalEnvironment = env.CLIENT_ENVIRONMENT === 'local';

	if (isLocalEnvironment) {
		return <Navigate to={loginRoute.fullPath} />;
	}

	return <AccessDeniedPage />;
};
